/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { webHookNtechMatchedCardRequestSchema } from "./webHookNtechMatchedCardRequestSchema.ts";

export const webHookNtechRequestSchema = z.object({
	matched_card: webHookNtechMatchedCardRequestSchema,
});
